import { render } from "./LatestArticleList.vue?vue&type=template&id=0cec6818"
import script from "./LatestArticleList.vue?vue&type=script&lang=js"
export * from "./LatestArticleList.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/times/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__